import React from 'react'
import styled from 'styled-components'

const media = {
  medium: '@media(min-width:700px)',
  large: '@media(min-width:1200px)',
  xLarge: '@media(min-width:1800px)'
}

const FooterStyles = styled.footer`
  background: var(--black);
  color: var(--light);
  /* display:flex; */
  justify-content: space-between;
  font-family:var(--sans);
  font-weight:500;
  letter-spacing: 0.02em;
  /* background:yellow; */

  ${media.medium}{
    display:flex;
  }
  
  /* position:fixed;
  bottom:0;
  left:0;
  width:100vw;
  z-index:-2; */

  p {
    margin-bottom: 0;
    padding: 1em;
    font-size: var(--small-text);
    letter-spacing: 0.08em;
    margin: 0;
    width:75%;
    font-weight:400;
    color: rgb(120,120,120);


  }
  ul{
    list-style:none;
    font-size:var(--small-text);
    margin:1em;
    margin-bottom:2em;
    padding-left:1em;
    padding-bottom:1em;
    font-weight:400;
    /* background:red; */

    ${media.medium}{
      display:flex;
      margin-bottom:0;
      padding-left:0;

    }

    /* background:red; */
    
    align-items:right;
  }
  li {
    color: white;
    align-items:right;
    margin-right:1em;
    /* text-transform:uppercase; */
    /* background:blue; */
    a {
      color: rgb(120,120,120);
      text-decoration:none;
    }
  }
`

export default function Footer ({ social }) {
  return (
    <FooterStyles>
      <p>&copy; CCA MFA {new Date().getFullYear()}</p>
      {social.map((content, index) => (
        <ul className="links">
          {content.social_links.map((link, i) => (
            <li>
              <a href={link.url}>{link.link_text}</a>
            </li>
          ))}
        </ul>
      ))}

    </FooterStyles>
  )
}
